/**
 * Tipos sintéticos que ampliam o snapshot sem ampliar o contrato do backend.
 *
 * Controles de formulário continuam usando o próprio `type` do DOM. Todo item
 * que não é um controle precisa pertencer a esta lista fechada.
 *
 * O vocabulário é lido pelo modelo: cada item do snapshot viaja com o seu tipo
 * até o prompt, e é por ele que o modelo separa "a tela está no modo X" de "a
 * linha do dia 3 mostra Y". Tipo novo aqui é tipo novo no prompt — não invente
 * um por tela.
 */
export const TIPOS_DE_ITEM_DE_TELA = [
  // ── Estrutura: o que a tela É e como está configurada ──────────────────
  /** Identidade da tela, publicada pela própria página (nunca a URL). */
  'tela',
  /** Modo/visão corrente: por empregado, por local de trabalho, por dia… */
  'modo',
  /** Recorte temporal em foco (competência, intervalo de datas). */
  'periodo',
  /** Bloco nomeado dentro da tela (cabeçalho, somatórios, acordeão). */
  'secao',
  /** Tabela, grade ou lista, com o resumo do que ela lista. */
  'regiao_tabela',
  /** Coluna de uma região tabular, na ordem em que a pessoa a vê. */
  'coluna',
  /** Aba selecionada de um conjunto de abas. */
  'estado_aba',
  /** Filtro ativo que restringe o que a tela mostra. */
  'estado_filtro',
  /** Quantidade que descreve a tela ("linhas carregadas", "selecionadas"). */
  'contagem',

  // ── Dados: o que está à vista ──────────────────────────────────────────
  /** Uma linha da região tabular, com os valores das colunas. */
  'regiao_linha',
  /** Valor avulso exibido fora de tabela (cartão, destaque, rótulo+valor). */
  'valor',
  /** Somatório/total calculado que a tela exibe. */
  'total',

  // ── Ações e campos: o que a pessoa pode fazer ou preencher ─────────────
  /** Botão, link ou item de menu acionável. */
  'acao'
] as const

export type TipoDeItemDeTela = typeof TIPOS_DE_ITEM_DE_TELA[number]

/** Tipos que descrevem a ESTRUTURA da tela — a primeira lista do contrato. */
export const TIPOS_DE_ESTRUTURA: readonly TipoDeItemDeTela[] = [
  'tela',
  'modo',
  'periodo',
  'secao',
  'regiao_tabela',
  'coluna',
  'estado_aba',
  'estado_filtro',
  'contagem'
]

/** Tipos que descrevem os DADOS exibidos — a segunda lista do contrato. */
export const TIPOS_DE_DADOS: readonly TipoDeItemDeTela[] = [
  'regiao_linha',
  'valor',
  'total'
]

export function ehTipoDeEstrutura (tipo: string): boolean {
  return (TIPOS_DE_ESTRUTURA as readonly string[]).includes(tipo)
}

export function ehTipoDeDados (tipo: string): boolean {
  return (TIPOS_DE_DADOS as readonly string[]).includes(tipo)
}
